import styled from 'styled-components';
import CarDetailComponent from '../../../CarDetail';

export const CarDetail = styled(CarDetailComponent)`
  width: 100%;
  margin-bottom: 0;
`;
